import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { AppContext } from '../../../../../appContext/AppContext';
import AutocompleteV2 from '../../../../../component/AutocompleteObjectV2';
import { IconMenu } from '../../../../../component/IconSvg';
import SelectTree from '../../../../../component/SelectTree';
import { CODE, RESPONSE_MESSAGE } from '../../../../../utils/Constant';
import { TreeChiDinhDichVu } from '../../../../constants/KhamBenh';
import { LOAI_VAT_TU } from '../../../../constants/VatTu';
import { IKhoThuoc } from '../../../../models/ThuocModels';
import {
	getDanhSachLoaiVatTu
} from '../../../../services/VatTuService';
import { getListVatTu, getWarehouseByVisitCode } from '../../common';
import { useKeVatTuContext } from '../../context';

type Props = {
	donVatTuDetail: any;
	disableSelectKhoVatTu?: boolean;
	generalInfo?: any
};

const TreeVatTu = ({ donVatTuDetail, disableSelectKhoVatTu, generalInfo }: Props) => {
	const { setIsLoading } = useContext(AppContext);
	const { setTreeNodeValue, setTreeValue, treeValue, setSelectedNode } = useKeVatTuContext();
	
	const [nodeIdSelected, setNodeIdSelected] = useState<string>('');
	const [treeData, setTreeData] = useState<any>(TreeChiDinhDichVu);
	const [codeCollapses, setCodeCollapses] = useState<string[]>([]);
	const [danhSachTuVatTu, setDanhSachTuVatTu] = useState<IKhoThuoc[]>([]);

	const khoVatTuDefaultValue = danhSachTuVatTu.find(
		row => row.id === parseInt(donVatTuDetail?.warehouseId)
	);
	const { visit } = generalInfo ?? {};
	
	useEffect(() => {
		getWarehouses();
	}, []);

	useEffect(() => {
		if (treeValue?.id) {
			getLoaiVatTu();
			if (nodeIdSelected) {
				setNodeIdSelected('');
				setTreeNodeValue([]);
			}
		}
	}, [treeValue?.id]);

	useEffect(() => {
	  if (khoVatTuDefaultValue) {
		  setTreeValue(khoVatTuDefaultValue);
	  }
	}, [khoVatTuDefaultValue]);

	const getWarehouses = async () => {
		try {
			const data: any = await getWarehouseByVisitCode(
				visit?.visitObjectTypeCode,
				'item', 
				generalInfo
			);
			if (data) {
				setDanhSachTuVatTu(data);
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	const getLoaiVatTu = async () => {
		try {
			const { code, data } = await getDanhSachLoaiVatTu();
			if (CODE.SUCCESS === code && data) {
				const dataConverted = {
					code: 'all',
					name: 'Kho vật tư',
					icon: <IconMenu />,
					filter: [
						{
							name: 'Tất cả vật tư',
							code: 'all-items',
							filter: data.content,
						},
					],
				};
				setTreeData(dataConverted);
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	const onNodeSelected = async (data: any) => {
		try {
			setSelectedNode(data);
			
			if (!data) {
				setTreeNodeValue([]);
				return;
			};

			const result = await getListVatTu({
				materialType: data.code,
				warehouseId: treeValue.id,
				materialGroup: LOAI_VAT_TU.VAT_TU,
				pageIndex: 1,
				pageSize: 100,
			}, setIsLoading);
			
			setTreeNodeValue(result ?? []);
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			<div className="spaces px-12 py-5 h-42">
				<AutocompleteV2
					placeholder={`Chọn ${generalInfo?.forDVKT ? 'tủ trực' : 'kho'} vật tư`}
					options={danhSachTuVatTu}
					name="tuVatTu"
					className="spaces mt-10 h-30 rounded-0"
					value={treeValue || khoVatTuDefaultValue}
					onChange={selectedOption => {
						setTreeValue(selectedOption);
					}}
					isDisabled={disableSelectKhoVatTu}
				/>
			</div>
			<div>
				{treeValue?.id && treeData && (
					<SelectTree
						className="spaces top-15 w-100 py-2 ps-4 h-calc-vh-154 border border-top-0 overflow-auto"
						idSelected={nodeIdSelected}
						handleChangeSelectId={setNodeIdSelected}
						getSelectedItem={onNodeSelected}
						selectTree={treeData}
						codeCollapses={codeCollapses}
						handleChangeCollapsesCode={setCodeCollapses}
					/>
				)}
			</div>
		</>
	);
};

export default TreeVatTu;
